<template>
  <div>
    <Top></Top>
    <Rotation :type="lbt"></Rotation>
    <div id="middleCon">
      <div class="galleryCon">
        <p><i class="icon"></i>精品图片</p>
      </div>
      <div class="toggBtn">
        <el-button class="bton" @click="pushSearch(item)" v-for="(item, index) in btn" :key="index">{{
          item
        }}</el-button>
      </div>

      <div class=" myTabContent">
        <div class="imgBox" @click="pushPhotoDetial(item.photoId)" v-for="(item, index) in JpImg" :key="index">
          <div id="posTop">
            <div class="address">
              {{ item.address }}
            </div>
          </div>
          <div id="posBottom">
            <img :src="item.headImage" alt="">
            <div class="name">{{ item.username }}</div>
          </div>
          <img v-lazy="item.photoUrl + '?x-oss-process=image/resize,h_300'" />
        </div>
      </div>


      <!-- 图片2 -->
      <div class="galleryCon">
        <p><i class="icon"></i>新图速递</p>
        <!-- <span class="imgMore">查看更多</span> -->
      </div>

      <div class="myTabContent">
        <div class="imgBox" @click="pushPhotoDetial(item.photoId)" v-for="(item, index) in newImgList" :key="index">
          <div id="posTop">
            <div class="address">
              {{ item.address }}
            </div>
          </div>
          <div id="posBottom">
            <img :src="item.headImage" alt="">
            <div class="name">{{ item.username }}</div>
          </div>
          <img v-lazy="item.photoUrl + '?x-oss-process=image/resize,h_300'" />
        </div>
      </div>
    </div>
    <!-- 回到顶部 -->
    <el-backtop :visibility-height="300">
      <div class="inn">
        <img src="@/imgs/backtop.png" alt="">
      </div>
    </el-backtop>
    <service />
    <shopFloat />
    <Foot></Foot>
  </div>
</template>
<script>
import { setLocalStorage } from "../utils/auth";
import { getLocalStorage } from "../utils/auth";
import { setToken } from "../utils/auth";
import Top from "../components/top";
import Rotation from "../components/rotation.vue";
import Foot from "../components/foot.vue";
import Aboution from "../components/aboution.vue";
var justifiedLayout = require("justified-layout");

export default {
  components: { Top, Rotation, Foot, Aboution },
  name: "gallery",
  data() {
    return {
      lbt: 'photo',//传给子组件用来区别轮播图
      btn: [
        "自然风光",
        "美食小吃",
        "非遗文化",
        "西北风光",
        "热带海景",
        "城市风光",
        "最美乡村",
        "夏季消暑",
        "长白山",
        "沙滩",
        "古镇",
        "热带海景",
        "江景",
        "田园风光",
        "高楼",
        "乡村小道",
        "冬季",
        "山川河流",

      ],
      dataAr: [],
      dataArr: [],
      geometryList: "",
      user_url: "",
      page: 1,
      isactive: true,
      actindex: 1,
      tags: [],
      JpImg: [], //精品图片
      newImgList: [],//新片速递
    };
  },
  created() {
    this.getJpImg() //精品图片请求
  },
  methods: {
    // 点击按钮去搜索
    pushSearch(item) {
      let { href } = this.$router.resolve({
        path: '/photoSearchResule',
        query: {
          term: item,
          type: 'img'
        }
      })
      window.open(href, '_blank')
    },

    // 精品图片
    async getJpImg() {
      var res = await this.$axios.get('/homeReception/findPhotoBoutique', { params: { commendType: 2 } })
      // console.log(res);
      this.JpImg = res.data
      this.newImg()
    },

    // 新片速递
    async newImg() {
      var res = await this.$axios.get('/homeReception/newPhotoList', { params: { commendType: 2 } })
      // console.log(res);
      this.newImgList = res.data
    },

    // 点击图片跳转详情页
    pushPhotoDetial(id) {
      console.log(id);
      let routerUrl = this.$router.resolve({
        path: '/photoDetail',
        query: { id: id }
      })
      // console.log(routerUrl);
      window.open(routerUrl.href, "_brank")
    },


  },
};
</script>
<style  lang="scss" scoped>
// // 移动端
// @media screen and (min-width: 375px) and (max-width: 1456px) {
//   #middleCon {
//     width: 100% !important;
//     padding: 10px;

//     .galleryCon {
//       width: 100% !important;
//       padding: 0 15px !important;
//     }

//     .toggBtn {
//       width: 100% !important;
//       height: 195px !important;

//       .bton {
//         width: 245px !important;
//         height: 84px !important;
//         border-radius: 50px !important;
//       }
//     }

//     .myTabContent {
//       width: 100%;

//       .imgBox {
//         width: 460px;
//         height: 298px;
//         margin-bottom: 15px;
//       }
//     }
//   }
// }

@-webkit-keyframes loading {
  0% {
    background-position: 100% 50%
  }

  to {
    background-position: 0 50%
  }
}

@keyframes loading {
  0% {
    background-position: 100% 50%
  }

  to {
    background-position: 0 50%
  }
}

#middleCon {
  width: 1600px;
  margin: 0 auto;

}


.icon {
  display: inline-block;
  height: 20px;
  width: 20px;
  background-image: url("../imgs/befor.svg");
  background-repeat: no-repeat;

  margin-right: 10px;
  z-index: 2;
}




.galleryCon {
  width: 100%;
  height: 30px;
  margin: 50px auto 10px;
  display: flex;
  align-items: center;
  justify-content: start;

  .icon {
    vertical-align: middle;
  }

  p {
    font-size: 23px;
    font-weight: 500;
  }

  .imgMore {
    float: right;
    padding-right: 20px;
  }

}


// 切换按钮
.toggBtn {
  width: 100%;
  margin: 40px auto 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  height: 155px;

  .bton {
    width: 165px;
    height: 54px;
    border-radius: 30px;
    color: #7c7c7c;
    margin: 0 !important;
  }
}

// 图片盒子
.myTabContent {
  width: 100%;
  margin: 30px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;


}


// 图片遮罩
.imgBox {
  position: relative;
  width: 308px;
  height: 228px;
  margin-bottom: 12px;
  overflow: hidden;
  margin-right: 14px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* 以下代码实现背景动画效果 */
    animation: loading 1.4s ease infinite;
    -webkit-animation: loading 1.4s ease infinite;
    background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #ccc), color-stop(37%, #e3e3e3), color-stop(63%, #ccc));
    background-image: -o-linear-gradient(left, #ccc 25%, #e3e3e3 37%, #ccc 63%);
    background-image: linear-gradient(90deg, #ccc 25%, #e3e3e3 37%, #ccc 63%);
    background-size: 400% 100%;
    transition: all 0.3s;



    &:hover {
      transform: scale(1.02);
    }
  }

  &:nth-child(5n) {
    margin-right: 0 !important;
  }

  &:hover #posBottom {
    bottom: 0,
  }

  &:hover #posTop {
    top: 0,
  }
}

#posTop {
  width: 100%;
  height: 40px;
  background: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
  position: absolute;
  left: 0;
  top: -50px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  padding: 0 10px;
  z-index: 111;

  .address {
    color: #fff;
    font-size: 13px;

  }
}

#posBottom {
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
  position: absolute;
  left: 0;
  bottom: -50px;
  transition: all 0.2s;
  padding: 0 10px;
  z-index: 111;

  img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }

  .name {
    margin-left: 8px;
    color: #fff;
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/gallery.vue